// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__4PZQu","logo":"Navbar_logo__71Bp2","link":"Navbar_link__ZW1H3"};